// // protectedroute.tsx
// import React from 'react';
// import { Route, Navigate } from 'react-router-dom';

// const useAuth = () => {
//   const user = localStorage.getItem('token');
//   // console.log("user:", user);
//   return user; // Returning token directly
// }

// const ProtectedRoute = ({ component: Component, ...rest }: any) => {
//   const token = useAuth(); // Retrieve token
  
//   // Render the provided component if user is authenticated, else navigate to login
//   return token ? <Component {...rest} /> : <Navigate to="/login" />;
// }

// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';

const useAuth = () => {
  const token = localStorage.getItem('authTokenlogin');
  return Boolean(token); // Returns true if token exists, otherwise false
};

interface ProtectedRouteProps {
  component: React.ComponentType<any>; // The component to render
  [key: string]: any; // Allow additional props
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const isAuthenticated = useAuth(); // Check if the user is authenticated

  return isAuthenticated ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;

